import {apiSlice} from './apiSlice';
import {PaginatedQueryParams} from '../../types/apiTypes';
import {FormLettersResponse, SendFormLetterParams} from '../../types/formLettersTypes';

export const communicationsInjectedEndpoints = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getFormLetters: builder.query<FormLettersResponse, PaginatedQueryParams>({
            query: ({page = 1, perPage = 10}) => ({
                url: '/notification_samples',
                params: {page, per_page: perPage}
            }),
            providesTags: ['FormLetters'],
        }),
        sendFormLetter: builder.mutation<void, SendFormLetterParams>({
            query: ({notification_id, email}) => ({
                url: '/notification_samples/preview',
                method: 'POST',
                body: {notification_id, email},
            }),
            invalidatesTags: ['FormLetters'],
        }),
    }),
});

export const {
    useGetFormLettersQuery,
    useSendFormLetterMutation,
} = communicationsInjectedEndpoints;
